"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClosest = getClosest;
function getClosest(selector, element) {
  var firstChar = selector.charAt(0);
  for (var i = element; i !== document.documentElement; i = i.parentElement) {
    if (firstChar === '.') {
      if (i.classList.contains(selector.substr(1))) {
        return i;
      }
    }
    if (firstChar === '#') {
      if (i.id === selector.substr(1)) {
        return i;
      }
    }
    if (firstChar === '[') {
      var attributes = selector.substr(1, selector.length - 2).replace(/"/g, '').split('=');
      if (i.getAttribute(attributes[0]) === attributes[1]) {
        return i;
      }
    }
    if (i.tagName.toLowerCase() === selector) {
      return i;
    }
  }
  return null;
}